import Cookies from 'js-cookie'
import utils from './utils'

export default {
    /**
     * 获取cookie
     * @param {String} key 
     * @param {String} domain 可设置，不传默认null
     * @param {Boolean} isDecrypt 是否解密 true解密
     * @returns 
     */
     getCookie:function(key,domain,isDecrypt=true) {
        let str = ''
        if(domain) {
            str = Cookies.get(key,{domain:domain});
        } else {
            str = Cookies.get(key);
        }
        if(str) {
            if(isDecrypt){
                return utils.getDecrypt(str);
            }
            return str;
        } else {
            return str;
        }
    },
    /**
     * 设置cookie
     * @param {String} key 
     * @param {Object} model 对象
     * model.value 值
     * model.domain 域名
     * model.expires 过期时间 分钟
     * @param {Boolean} isEncrypt 是否加密 true加密 false解密
     * @returns 
     */
    setCookie: function(key,model = {},isEncrypt = true) {
        var param = {}
        if(model.domain) {
            param.domain = model.domain;
        }
        if(model.expires !== null) {
            var millisecond = new Date().getTime();
            param.expires = new Date(millisecond + 60 * 1000 * model.expires);
        }
        if(param) {
            if (isEncrypt){
                return  Cookies.set(key, utils.getEncrypt(model.value), param);
            } else {
                return  Cookies.set(key, model.value, param);
            }
            
        } else {
            if(isEncrypt){
                return  Cookies.set(key, utils.getEncrypt(model.value));
            } else {
                return  Cookies.set(key, model.value);
            }
        }
    },
    /**
     * 删除cookie
     * @param {String} key 
     * @param {Object} model 对象
     * model.domain 域名
     * @returns 
     */
    removeCookie: function(key,model) {
        if(model) {
            return Cookies.remove(key,model);
        } else {
            return Cookies.remove(key);
        }
    }
}
